import { render } from "./cardCenter.vue?vue&type=template&id=caf4308e&scoped=true"
const script = {}

import "./cardCenter.vue?vue&type=style&index=0&id=caf4308e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf4308e"]])

export default __exports__